// extracted by mini-css-extract-plugin
export default {"container":"hoc_container__Ler-k","heading":"hoc_heading__ifkLJ","sub_heading":"hoc_sub_heading__y-iBj"};